enum APP_FONT_FAMILIES {
  manrope = '"Manrope", sans-serif',
  readexPro = '"Readex Pro", sans-serif',
  ibmPlexMono = '"IBM Plex Mono", monospace',
  helveticaNeue = '"Helvetica Neue", Arial, sans-serif',
}

export { APP_FONT_FAMILIES };

